import { render, staticRenderFns } from "./NoApprovalAlert.vue?vue&type=template&id=4430b3d9&scoped=true&"
import script from "./NoApprovalAlert.vue?vue&type=script&lang=js&"
export * from "./NoApprovalAlert.vue?vue&type=script&lang=js&"
import style0 from "./NoApprovalAlert.vue?vue&type=style&index=0&id=4430b3d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430b3d9",
  null
  
)

export default component.exports